import { render, staticRenderFns } from "./Headings.vue?vue&type=template&id=39b5c7c7&"
import script from "./Headings.vue?vue&type=script&lang=js&"
export * from "./Headings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports